module.exports = __webpack_public_path__ + "static/media/WTP_2022.21698680.png";